export default __webpack_public_path__ + "static/media/Logo_DEX.2dcfe874.svg";